import { render, staticRenderFns } from "./better-scroll.vue?vue&type=template&id=4f970602&scoped=true&"
import script from "./better-scroll.vue?vue&type=script&lang=js&"
export * from "./better-scroll.vue?vue&type=script&lang=js&"
import style0 from "./better-scroll.vue?vue&type=style&index=0&id=4f970602&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f970602",
  null
  
)

export default component.exports